import { createContext } from 'react';

export const ApiIntegrationsContext = createContext();
